import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getVehicles } from "../../../actions/admin/vehicle";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import VehicleItem from "./VehicleItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Name", width: "tw:w-[240px]" },
  { key: "vehicleType", title: "Vehicle Type", width: "tw:w-[220px]" },
  { key: "registration", title: "Vehicle Registration", width: "tw:w-[220px]" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "createdOn", title: "Created Date", width: "tw:w-[160px]" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const VehicleList = () => {
  const vehicle = useSelector((state) => state.vehicle);
  const { loading, vehicles } = vehicle;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getVehicles());
  }, [dispatch]);

  return (
    <AdminPage title="Vehicle List" actions={<AdminCreateButton to="/admin/addvehicle" label="Add Vehicle" />}>
      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1180}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!vehicles?.length}
        emptyText="No vehicles found."
      >
        {vehicles?.map((item, index) => (
          <VehicleItem key={item._id} vehicle={item} count={index} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default VehicleList;
